import {
  BillingCycleOption,
  BillingPlanOption,
  InvitationStatus,
  NotificationType,
  ReportStatus,
  TeammateStatus,
  TransactionType,
  UserBillingType,
  UserRole,
} from 'globals/types';
import Routes from 'routes';

export default {
  // ===============================================
  // Phrases, words, labels...
  // ===============================================
  suspiciousEmails: 'Suspicious emails',
  redirectUrl: 'Redirect URL',
  suspiciousRedirects: 'Suspicious redirects',
  manageYourTeam: 'Manage your team',
  yourProfile: 'Your Profile',
  profileSettings: 'Profile settings',
  invoiceHistory: 'Invoice History',
  showLess: 'Show less',
  showAllInvoices: 'Show all invoices',
  planDetails: 'Plan details',
  selectedType: 'Selected type',
  trial: 'Trial',
  daysLeft: 'days left',
  subscribe: 'Subscribe',
  unsubscribe: 'Unsubscribe',
  minimumSpending: 'Minimum spending',
  perCustomer: 'Per customer',
  personal: 'Personal',
  business: 'Business',
  totalCustomers: 'Total customers',
  balance: 'Balance',
  tabs: 'Tabs',
  moreInfo: 'More cashflow-summary',
  add: 'Add',
  addNew: 'Add new',
  addAnother: 'Add another',
  address: 'Address',
  setNew: 'Set new',
  update: 'Update',
  expenditureTable: 'Expenditure table',
  simpleTable: 'Simple table',
  more: 'See more',
  export: `Export`,
  download: `Download`,
  close: `Close`,
  cancel: `Cancel`,
  save: `Save`,
  saveChanges: `Save changes`,
  doItLater: 'I will do it later',
  skip: 'Skip this one',
  skipShort: 'Skip',
  delete: `Delete`,
  amount: `Amount`,
  date: `Date`,
  incidents: `Incidents`,
  totalIncome: `Total income`,
  logIn: `Log in`,
  logOut: `Log out`,
  signIn: `Sign in`,
  password: `Password`,
  currentPassword: `Current password`,
  newPassword: `New password`,
  repeatNewPassword: `Repeat new password`,
  updatePassword: `Update password`,
  reset: `Reset`,
  resetPassword: `Reset password`,
  repeatPassword: 'Repeat Password',
  createPassword: `Create Password`,
  resendCode: `Resend the code`,
  changePhoneNumber: `Change phone number`,
  changeCreditCard: `Change credit card`,
  changePassword: `Change password`,
  change: `Change`,
  billingInfo: `Billing info`,
  sum: `Sum`,
  success: `Success`,
  dashboard: `Dashboard`,
  backToDashboard: `Back to dashboard`,
  vat: `VAT`,
  vatNumber: `VAT number`,
  ueVatNumber: `UE Vat number`,
  cardHolderName: `Card holder name`,
  validCardNumber: `Valid card number`,
  expiryMonth: `Expiry month`,
  expiryYear: `Expiry year`,
  cvvCsc: `CVV/CSC`,
  changeCategory: `Change category`,
  email: `Email`,
  type: `Type`,
  search: `Search`,
  emailStatus: `Email status`,
  reference: `Reference`,
  role: `Role`,
  flags: `Flags`,
  lastActivity: `Last activity`,
  verify: 'Verify',
  continue: 'Continue',
  name: 'Name',
  firstName: 'First name',
  filter: 'Filter',
  lastName: 'Last name',
  companyName: 'Company name',
  phoneNumber: 'Phone number',
  industry: 'Industry',
  chooseIndustry: 'Choose industry',
  position: 'Position',
  choose: 'Choose',
  chooseDepartment: 'Choose your department',
  chooseNumber: 'Choose number',
  chooseOption: 'Choose option',
  next: 'Next',
  invite: 'Invite',
  inviteCustomer: 'Invite customer',
  inviteNewCustomer: 'Invite new customer',
  invoiceRecipientName: 'Invoice recipient name',
  user: 'User',
  userDetails: 'User details',
  inviteUser: 'Invite user',
  removeUser: 'Remove user',
  inviteNewUser: 'Invite new user',
  teammate: 'Teammate',
  inviteNewTeammate: 'Invite new teammate',
  inviteTeammate: 'Invite teammate',
  removeTeammate: 'Remove teammate',
  company: 'Company',
  person: 'Person',
  selectCustomerType: 'Select Customer Type',
  magicLink: 'Magic Link',
  recentInvitations: 'Recent Invitations',
  seeAllInvitations: 'See all invitations',
  invitedBy: 'Invited by',
  inviteNew: 'Invite new',
  opened: 'Opened',
  send: 'Send',
  activity: 'Activity',
  apiGenerated: 'API Generated',
  revoke: 'Revoke',
  latestReports: 'Latest Reports',
  seeAllReports: 'See all reports',
  leaderboard: 'Leaderboard',
  seeAll: 'See all',
  invitations: 'Invitations',
  reports: 'Reports',
  report: 'Report',
  customer: 'Customer',
  createdAt: 'Created at',
  status: 'Status',
  reportStatus: 'Report status',
  sendLink: `Send link`,
  keys: `Keys`,
  redirects: `Redirects`,
  sandbox: `Sandbox`,
  production: `Production`,
  clientId: `Client ID`,
  clientSecret: `Client Secret`,
  city: `City`,
  country: `Country`,
  postCode: `Post code`,
  readDocs: `Read docs`,
  docs: `Docs`,
  origin: `Origin`,
  http: `http://`,
  addOrigin: `Add origin`,
  comment: `Comment`,
  yourComment: `Your comment`,
  androidScheme: `Android Scheme`,
  androidPackage: `Android Package`,
  iOsBundleIdentifier: `iOS Bundle Identifier`,
  notifications: `Notifications`,
  teammates: `Teammates`,
  edit: 'Edit',
  editUser: 'Edit user',
  editTeammate: 'Edit teammate',
  yes: 'Yes',
  no: 'No',
  remove: 'Remove',
  fixThem: `I'll fix them`,
  confirmEmail: 'Confirm email',
  confirmDomain: 'Confirm domain',
  confirmInvitations: 'Confirm invitations',
  confirmNotifications: 'Confirm notifications',
  iConfirm: 'I confirm',
  canSeeOtherUsers: 'Can see other users',
  transactionType: 'Transaction type',
  paymentMethod: 'Payment Method',
  paid: 'Paid',
  unpaid: 'Unpaid',
  pdf: 'PDF',
  payNow: 'Pay now',
  upgradeHeadline: 'Simple and transparent',
  billMonthly: 'Bill monthly',
  billYearly: 'Bill yearly',
  billYearlySaveInfo: '(save 15%)',
  startsFrom: 'Starts from',
  from: 'From',
  to: 'To',
  account: 'Account',
  upgrade: `Upgrade`,
  upgradeMethodPayment: `Update payment method`,
  upgradeYourPlan: `Upgrade your plan`,
  billingCycle: `Billing cycle`,
  enterprise: `Enterprise`,
  payAsYouGrow: `Pay As You Grow`,
  message: `Message`,
  checkReports: `Check reports`,
  checkInvitations: `Check invitations`,
  bank: 'Bank',
  bankAccounts: 'Bank accounts',
  banks: 'Banks',
  others: 'Others',
  billings: 'Billings',
  billingType: 'Billing type',
  welcome: 'Welcome',
  developers: 'Developers',
  settings: 'Settings',
  settingsFlags: 'Settings (Flags/Roles)',

  // ===============================================
  // SLonger Sentences
  // ===============================================

  // Titles, descriptions, instructions...
  suggestedPriceCaption: `Suggested price per customer`,
  passwordInstruction: `Use 8 or more characters with a mix of letters, numbers & symbols.`,
  invitationFormInstruction:
    'Fill in the details below to invite your teammate to use FriendlyScore',
  magicLinkInstruction:
    'Simply copy and send the link below to your customers to enable them to begin sharing bank transaction data.',
  inviteCustomerWithMagicLink: 'Invite customer using Magic Link',
  upgradeSidebarInfo: [
    `Upgrade your free plan to`,
    `Pay as you grow`,
    `for more reports.`,
  ],
  billingMonthlyDescription:
    'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna.',
  billingYearlyDescription:
    'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna.',
  billingSpecialDescription:
    'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna.',
  billingSummary:
    'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do',
  billingLegend: `Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vestibulum venenatis ac nibh et finibus. Pellentesque non ultrices erat. Proin a fringilla lorem, vitae porttitor velit. Nunc auctor diam massa, at auctor velit hendrerit id. Nunc at magna feugiat, sagittis odio lacinia, varius ante. Class aptent taciti sociosqu ad litora torquent per conubia nostra.`,
  tellMoreAboutYourProject: `Tell us a bit more about your project and we’ll get back to you with an offer`,
  tellAboutYourProjectCaption: `Tell us about your project`,

  // Modals info
  defaultFallbackComponentInfo: `Sorry, we have some internal issue. We couldn't load this component`,
  enterpriseMessageSendSuccessModalInfo:
    'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Quisque tristique eros mauris, non sollicitudin ipsum sollicitudin at Phasellus ultrices vitae ipsum in lacinia.',

  // Tooltips
  paymentMethodTooltipInfo: `Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna.`,
  billingInfoTooltipInfo: `Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna.`,
  enterpriseMessageTooltipInfo:
    'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna.',

  // Questions
  removeUserQuestion: 'Do you really want to remove',
  sendInvitationEmailQuestion:
    'Are you sure you want to send this invitation to this email',
  sendInvitationDomainQuestion:
    'Are you sure you want to send this invitation to someone outside the domain?',
  sendInvitationsInvalidEmailsQuestion:
    'Some of the entered e-mails are incorrect. Do you want to continue anyway?',
  sendRedirectsInvalidUrlQuestion:
    'Some of the entered redirects are incorrect. Do you want to continue anyway?',
  logInQuestion: `Already have an account?`,
  logInGoBackQuestion: `Want to go back?`,
  signInQuestion: `Don’t have an account?`,
  resetPasswordQuestion: `Forgot password?`,
  resetPasswordQuestionLong: 'Do you really want to reset password for',
  tailoredPricingQuestion: `Need tailored pricing?`,
  howManyCustomersQuestion: `How many customers do you process a month?`,
  changeCurrentPasswordQuestion: `Do you want to change your current password?`,
  haveAccountQuestion: `Already have an account?`,

  // Alerts, Warnings... info
  wrongCreditCardAlertInfo: `It seems that something is wrong with your credit card. It might be no longer valid or might contain no funds.`,
  unsubscribedWarningInfo: `You are unsubscribed. We will not be able to charge you automatically from month to month, which may temporarily disable your account.`,

  // Notifications Success
  updateOriginNotificationSuccess: `Web Origins are updated`,
  updateIosAndroidRedirectsNotificationSuccess: `Android and iOS redirects are updated`,
  updateEmailNotificationSuccess: 'Your email addresses are updated',
  removeUserNotificationSuccess: 'User was successfully removed',
  resetPasswordNotificationSuccess: 'Password was successfully reset',
  saveChangesNotificationSuccess: 'Changes are successfully saved',
  invitationSendNotificationSuccess: 'Invitation was successfully send!',
  creditCardChangeNotificationSuccess: 'Credit card was successfully changed!',
  billingInfoChangeNotificationSuccess:
    'Billing info was successfully changed!',
  invoicePayNotificationSuccess: {
    suffix: 'was paid successfully',
    prefix: 'Invoice from',
  },
  subscribeNotificationSuccess: 'You are successfully subscribed',
  messageSendNotificationSuccess: 'Your Message was successfully sent',
  userDetailsUpdateNotificationSuccess: 'User details are updated',
  copyPasteSuccessNotificationSuccess: { suffix: 'is copied to clipboard' },
  passwordUpdateNotificationSuccess: 'Your password is updated',

  // Notifications Error
  appContextNotificationError: `appContext must be used within the AppContextProvider!`,
  openReportNotificationError: `Sorry, but you can't open this report. Only reports with Ready status can be opened.`,
  copyPasteNotificationError: 'Oops, unable to copy',

  // Input Errors
  inputErrors: {
    'cc-name': `Card holder name field must contain at least one letter`,
    'cc-number': `This credit card number seems to be wrong. Please check it again.`,
    'cc-csc': `This CVV/CSC code is wrong or doesn't match to provided credit card number.`,
  },
  // Enums
  enums: {
    [InvitationStatus.SENT]: 'Sent, not opened',
    [InvitationStatus.REJECTED]: 'Rejected',
    [InvitationStatus.OPENED]: 'Opened',
    [ReportStatus.READY]: 'Ready',
    [ReportStatus.IN_PROGRESS]: 'In progress',
    [ReportStatus.BROKEN]: 'Broken',
    [TeammateStatus.ACTIVE]: 'Active',
    [TeammateStatus.SUSPENDED]: 'Suspended',
    [TeammateStatus.INACTIVE]: 'Inactive',
    [UserRole.USER]: 'User',
    [UserRole.ADMIN]: 'Admin',
    [UserRole.LEADER]: 'Leader',
    [UserRole.ACCOUNTANT]: 'Accountant',
    [UserRole.DEV]: 'Dev',
    [BillingCycleOption.MONTHLY]: 'Monthly',
    [BillingCycleOption.YEARLY]: 'Yearly',
    [NotificationType.BANKS]: 'Banks',
    [NotificationType.REPORTS]: 'Reports',
    [NotificationType.OTHERS]: 'Others',
    [UserBillingType.STANDARD]: 'Standard',
    [UserBillingType.ENTERPRISE]: 'Enterprise',
    [UserBillingType.EXCLUDED]: 'Excluded',
    [TransactionType.EXPENDITURE]: 'Expenditure',
    [TransactionType.INCOME]: 'Income',
    [TransactionType.TOP_EXPENDITURE]: 'Top expenditure',
    [TransactionType.TOP_INCOME]: 'Top income',
    [BillingPlanOption.ENTERPRISE]: 'Enterprise',
    [BillingPlanOption.PAY_AS_YOU_GROW]: 'Pay as you grow',
  },

  // ===============================================
  // Section/Pages
  // ===============================================

  // Pay As You Grow Section
  payAsYouGrowSection: {
    info: {
      prefix: 'Unlimited bank connections and API calls, 3 Dashboard Users.',
      suffix: 'minimum spend.',
    },
    minimumSpending: {
      suffix: '/mo',
    },
  },

  // Enterprise Section
  enterpriseSection: {
    subTitle: 'For large businesses',
    description: 'Enterprise-grade software and compliance support',
  },
  screenOfDeath: {
    title: 'Lorem ipsum dolor',
    description:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Quisque tristique eros mauris, non sollicitudin ipsum sollicitudin at. Phasellus ultrices vitae ipsum in lacinia.',
  },

  // Enterprise Section
  topBarSection: {
    description: `Lorem ipsum dolor sum Lorem ipsum dolor sum Lorem ipsum dolor sum`,
    buttonLabel: 'Billings',
  },

  // Developers Page
  developersPage: {
    keys: {
      sandboxUrl: '(Server URL: https://sandbox.friendlyscore.com)',
      productionUrl: '(Server URL: https://api.friendlyscore.com)',
    },
    redirects: {
      docsUrl: 'https://friendlyscore.com/developers/',
      webOrigin: {
        title: 'Web Origin',
        descriptionPrefix: 'Origin is a domain with protocol where ',
        descriptionSuffix: 'is allowed to be rendered.',
        descriptionNextLine:
          'The default allowed Origin is http://127.0.0.1:3000',
        url: 'https://friendlyscore.com/developers/web-component',
        linkLabel: 'Web Component',
      },
      iOsAndroid: {
        title: 'Android and iOS',
        descriptionPrefix: 'Redirect URLs return control to your app for',
        descriptionSuffix: 'or',
        iOsLinkLabel: 'iOS SDK',
        iOsUrl: 'https://friendlyscore.com/developers/ios',
        androidLinkLabel: 'Android SDK',
        androidUrl: 'https://friendlyscore.com/developers/android',
      },
    },
  },

  // Dashboard Page
  dashboardPage: {
    chart: {
      tabs: [
        {
          percentageLabel: 'last month!',
          effectivenessLabel: 'all time',
        },
        {
          percentageLabel: 'last month!',
          effectivenessLabel: 'all time',
        },
      ],
    },
  },

  // Welcome Dashboard Page
  welcomeDashboardPage: {
    mainBoard: {
      title: 'Your account has been created!',
      titleAccountant: 'Lorem ipsum dolor sit amet!',
      description:
        'FriendlyScore is the easiest way to obtain bank transaction information from your customers and get insights into their financial health. Enable your customers to begin sharing account information by choosing your preferred method from the options below.',
      descriptionAccountant:
        'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nullam fermentum tincidunt leo, non dignissim quam aliquet quis. Nunc id posuere tellus, ut tristique ante. Vestibulum imperdiet mi eget tellus mollis',
    },
    subTitle: 'Getting started points',
    subBoards: [
      {
        title: 'Email Invitations',
        description:
          'Send your customers a secure link to begin sharing bank transaction data with you via the FriendlyScore website. No software integration needed!',
        buttonLabel: 'How it works',
        buttonUrl: Routes.INVITE_CUSTOMER,
      },
      {
        title: 'Software Integration',
        description:
          'Get your API keys from our Developer section to access our software development toolkit. Customers can then connect their bank transaction data through your own website and mobile app.',
        buttonLabel: 'Get your API Keys',
        buttonUrl: Routes.DEVELOPERS,
      },
    ],
  },

  // Invitations Page
  invitationsPage: {
    title: 'Current list of invitations',
  },

  // Invite Customers Page
  inviteCustomersPage: {
    howItWorks: {
      title: 'How it works',
      caption: 'Three steps',
      iconBoxes: {
        invite:
          'Invite your customers using our email form or by sending them a Magic Link.',
        register:
          'Customer follows the link to register with FriendlyScore and authorise data sharing.',
        receiveReport:
          'You receive a report containing insights based on the shared data.',
      },
    },
  },

  // Reports Page
  reportsPage: {
    title: 'Current list of reports',
  },

  // Settings Page
  settingsPage: {
    notifications: {
      title: 'Update notification E-mails',
      subTitle:
        'Add email addresses below to receive notifications of new reports as soon as they become available. Multiple addresses may be added if separated by a comma.',
    },
    teammates: {
      title: 'Your team',
      subTitle:
        'Authorised teammates who have access to customer information, api keys or billing information',
    },
  },
};
